import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { buildImageObj } from '../../../lib/helpers'
import { imageUrlFor } from '../../../lib/image-url'
import BlockContent from '../../shared/blockContent'

import './caseStudiesListItem.css'

const CaseStudiesListItem = ({ data }) => {
  let wrapperStyle = {
    backgroundImage: '',
  }
  if (data.content.featuredImage && typeof data.content.featuredImage === 'object') {
    wrapperStyle.backgroundImage = `url(${imageUrlFor(buildImageObj(data.content.featuredImage))
      .width(512)
      .height(544)
      .url()})`
  }
  return (
    <div className="caseStudiesListItemWrapper">
      <Link
        to={'/work/' + data.content.slug.current}
        className="caseStudiesListItem"
        style={wrapperStyle}
      >
        <div className="content">
          {data.content.logo && (
            <img
              src={imageUrlFor(buildImageObj(data.content.fullLogo)).width(200)}
              alt={data.content.client + ' logo'}
              className="logo"
            ></img>
          )}
        </div>
      </Link>
      {data.content.title && typeof data.content.title === 'string' ? (
        <Link to={'/work/' + data.content.slug.current} className="projectTitle">
          {data.content.title}
        </Link>
      ) : (
        <Link to={'/work/' + data.content.slug.current} className="projectTitle">
          <BlockContent input={data.content.title}></BlockContent>
        </Link>
      )}
    </div>
  )
}

CaseStudiesListItem.propTypes = {
  data: PropTypes.object,
}

CaseStudiesListItem.defaultProps = {
  data: {
    content: {
      title: 'Component title',
      text: 'This is some component text just to demo the flow.',
    },
    media: {
      asset: 'mercedes-featured.png',
    },
    index: 0,
  },
}

export default CaseStudiesListItem
